import {Injectable} from '@angular/core';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Topic} from '../models/event';
import {Member} from '../models/member';
import {Ordered} from '../models/ordered';
import {Product} from '../models/product';
import {Subcategory} from '../models/subcategory';

import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError, retry} from 'rxjs/operators';
import {AuthService} from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class CaexService {

  public dolarCotation: number;
  
  public currentMember: any;
  public currentProduct: any;
  public currentOrdered: any;
  public currentCategory: any;

  public memberOrders: any[] = []

  public updateMemberSituation: boolean = false;

  constructor (
    private db: AngularFirestore,
    private fb: FormBuilder,
    private _httpClient: HttpClient,
    public _authService: AuthService,
  ) { }

  getMemberByCPF (cpf: string) {
    cpf = cpf.replace('.', '').replace('-', '')
    return this.db.collection<Member>('sbccv_members', ref => ref
      .where('cpf', '==', cpf)
    ).get();
  }


// 'id': '2vgQyqXZWjsrYWngGV6A',
// 'name': '50º Congresso da SBCCV • 2024'

  loadOrders () {
    return this.db.collection<Member>('sbccv_orders', ref => ref
      .where('product_id', '==', "2vgQyqXZWjsrYWngGV6A")
      .where('returnCode', '==', "00")
    ).get()
  }

  getOrdersByMemberId (member_id) {
    return this.db.collection<Member>('sbccv_orders', ref => ref
      .where('member_id', '==', member_id)
      .where('returnCode', '==', "00")
    ).get();
  }

  createMemberForm () {

    return this.fb.group({
      id: new FormControl(''),
      name: new FormControl('', [ Validators.required ]),
      email: new FormControl(''),
      cellPhone: new FormControl(''),
      cellPhonePrefix: new FormControl(''),
      cpf: new FormControl('', [ Validators.required ]),
      subCategory_id: new FormControl('', [ Validators.required ]),
      crm: new FormControl('')
    });

  }

  setMemberFormData (form: FormGroup, data: any) {
    form.controls.id.setValue(data.id);
    form.controls.name.setValue(data.name);
    form.controls.email.setValue(data.email);
    let prefix = data.cellPhonePrefix ? data.cellPhonePrefix : "+55";
    form.controls.cellPhonePrefix.setValue(prefix);
    form.controls.cellPhone.setValue(data.cellPhone);
    form.controls.cpf.setValue(data.cpf);
    form.controls.crm.setValue(data.crm);
    form.controls.subCategory_id.setValue(data.subCategory.id);
  }

  loadAllProducts () {
    return this.db.collection<Product>('sbccv_products', ref => ref
      .where('deleted', '==', false)
      .where('isAnnuity', '==', false)
      .where('active', '==', true)
      .where('available', '==', true)
      .where('available_purchase', '==', true)
      .orderBy('name', 'asc')).snapshotChanges()
  }

  load50Congress () {
    const id: string = "2vgQyqXZWjsrYWngGV6A" // *50º Congresso SBCCV • 2024
    return this.db.doc<Product>('sbccv_products/' + id)
      .get();
  }

  checkRequirements (member_id: string, product_id: string) {

    return this.db.collection<Ordered>('sbccv_orders', ref => ref
      .where('member_id', "==", member_id)
      .where('product_id', "==", product_id)
      .where('returnCode', "==", '00')
      .where('returnCode', "==", "00")).get()

  }

  loadEventTopics (event_id) {
    return this.db.collection<Topic>('sbccv_event_topics', ref => ref
      .where('event_id', '==', event_id)
      .where('deleted', '==', false)).get()
  }

  loadEventTopicSlots (event_id) {
    return this.db.collection<Topic>('sbccv_event_slots', ref => ref
      .where('event_id', '==', event_id)).get()
  }

  selectSubcategoriesCaex () {
    return this.db.collection<Subcategory>('sbccv_subcategories', ref => ref
      .where('front_desk', '==', false)
      .where('sponsor', '==', true)
      .orderBy("name")).snapshotChanges();
  }

  loadAllMembers () {
    return this.db.collection<Member>('sbccv_members', ref => ref
      .orderBy('name', 'asc')).snapshotChanges();
  }

  updateMember (member) {

    //  console.log("data: " + JSON.stringify(member))

    let id = member.id
    delete member.id

    return this.db.collection('sbccv_members')
      .doc(id)
      .set(Object.assign({}, member), {merge: true});
  }

  createOrder (payAsOverdue, balance, subscription, total, origin): Ordered {

    const user = this._authService.getLogged()
    const member = this.currentMember
    const product = this.currentProduct

    let order: Ordered = new Ordered()

    order.origin = origin

    order.member_id = member.id
    order.member_name = member.name
    order.member_email = member.email
    order.member_cellPhone = member.cellPhone
    order.member_cpf = member.cpf
    order.member_debit = balance

    order.category_id = member.subCategory.id
    order.category_name = member.subCategory.name

    order.date = new Date()

    order.value = subscription

    order.total = total

    order.payAsOverdue = payAsOverdue

    order.product_id = product.id
    order.product_name = product.name

    order.type = 'front-desk'
    order.payment_type = 'front-desk'
    order.returnCode = "00"

    order.cash_operator = {
      'id': user.uid,
      'name': user.displayName
    }

    return order

  }

  insertOrder (entity: Ordered) {
    delete entity.id;
    return this.db.collection('sbccv_orders').add(Object.assign({}, entity));
  }

  getUserSubscription (doc): Observable<any> {

    let url = 'https://us-central1-sbccv-proj.cloudfunctions.net/getUserSubscription';

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    const body: any = {'doc': doc}
    return this._httpClient.post<any>(url, body, httpOptions)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }
  
  getUserSubscription49 (doc): Observable<any> {

    let url = 'https://us-central1-sbccv-proj.cloudfunctions.net/getUserSubscription49';

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    const body: any = {'doc': doc}
    return this._httpClient.post<any>(url, body, httpOptions)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }

  handleError (error: HttpErrorResponse) {
    console.log(error.status)
    return throwError(error.status);
  };


  ////////////////////////////////////////////////////////////////////

  registerPresence (body): Observable<any> {

    //url
    let url = 'https://us-central1-sbccv-proj.cloudfunctions.net/registerPresence';

    // Headers
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: '5AA6C5E4-28E7-4EF9-A608-733B760D703D'
      })

    };

    return this._httpClient.post<any>(url, body, httpOptions)
      .pipe(
        retry(2),
        catchError(this.registerPresence_handleError)
      )

  }

  // Manipulação de erros
  registerPresence_handleError (error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Erro ocorreu no lado do client
      errorMessage = "client - " + error.error.message;
    } else {
      // Erro ocorreu no lado do servidor
      errorMessage = `server - Código do erro: ${ error.status }, ` + `menssagem: ${ error.message }`;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  };

}
